<head>
  <!-- Google Tag Manager -->

  <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

  <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
  <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
    style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div class="template" style="overflow:hidden">
  <!-- <div class="row">
        <div class="col" style="margin-top:2%">
            <img src="../../assets/img/logo-hd.png"/>
        </div>
        <div class="col">
            <img src="../../assets/img/footer.png"/>
        </div>
    </div> -->
  <br />
  <div class="row" *ngIf="!username" style="text-align: center">
    <div class="col">
      <div class="h1">Cosmic Algorithm Ltd - Analysis</div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <!-- <img src="https://cosmicmedia-a0ce.restdb.io/media/cbimage.png"> -->
      <br />
      <div *ngIf="!username">
        <app-main-graph></app-main-graph>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-global-news></app-global-news>
    </div>
  </div>
  <br /><br /><br />
  <div class="row" style="text-align: center;">
    <div class="col">
      <div class="elfsight-app-1bd35861-fde3-4be5-9dfd-a51de5105af6"></div>
    </div>
  </div>
  <br /><br />
</div>